export const convertDMSToDD = (DMS, ref) => {
    const degrees = DMS[0];
    const minutes = DMS[1];
    const seconds = DMS[2];
    let dd = degrees + minutes / 60 + seconds / 3600;
    if (ref === 'S' || ref === 'W') {
      dd = dd * -1;
    }
    return dd;
  };